import styled from 'styled-components';
const AddStyled = styled.div`
  .form-wrapper {
    /* min-height: 550px; */
    background: #ffffff;
    box-shadow: 0 0 5px 0 rgba(181, 181, 181, 0.26);
    border-radius: 12px;
    padding: 0 32px;
    padding-top: 24px;
    padding-bottom: 32px;
    .input {
      min-width: 720px;
      /* top: 35px; */
    }
    .label-require {
      color: #ff0000;
    }
    .label-name {
      color: #000;
      font-size: 14px;
    }

    .title {
      font-size: 20px;
      font-family: SourceHanSansCN;
      color: #000;
      line-height: 20px;
      font-weight: 500;
      margin-bottom: 32px;
    }
  }
  .button-group {
    margin-top: 24px;
    .finish {
      margin-right: 16px;
    }
    .reset {
      margin-right: 16px;
    }
    .exit {
      border: 1px solid #666464;
    }
  }
  .link {
    margin-top: 16px;
    font-size: 16px;
    text-decoration: underline;
    cursor: pointer;
  }
  .checkbox-radio-disabled-color .Mui-disabled {
    color: darkgray;
  }
`;
export default AddStyled;
